<template>
  <div id="list-item" class="e-list-wrapper  e-list-multi-line ">
    <span class="e-list-item-header">{{data.text}}</span>
    <span class="e-list-content">{{data.notes}}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
        data: {}
    }
  }
}
</script>

<style scoped>
.e-list-item-header {
  font-weight: bold;
}

.e-list-content {
} 
</style>